import * as Vue from 'vue'
const routes = [
  {
    name: 'zoom.index',
    path: '/zoom/:id',
    component: Vue.defineAsyncComponent(() => import('@/pages/zoom/Index.vue')),
    meta: {
      auth: true
    }
  }
]

export default routes
